<template>
  <FilterDateChip
    icon="calendar"
    :is-text="isText"
    :label="$t('search-filters.published-since.name')"
    :notice="$t('search-filters.published-since.notice')"
    :periods="periods"
    :value="value"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterDateChip from '@/components/filters/FilterDateChip';
import { INBOX_DATE_PICKER_PERIOD } from '@/util/constants/date-picker-periods';

/**
 * Publication-date dimension chip. Presentational: `:value` (date range array) in, `change`
 * (sorted dates array) out, which the page converts via datesArrayToObject.
 */
export default {
  name: 'PublicationChip',
  components: { FilterDateChip },
  props: {
    value: { type: Array, default: () => [] },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    periods() {
      return INBOX_DATE_PICKER_PERIOD;
    },
  },
};
</script>
